import { SettingService } from 'src/app/system-common/services/setting.service';
import { TabItem } from 'src/app/models/common/tab-items';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { PageHeader } from 'src/app/models/common/page-header';
import { Subscription } from 'rxjs';
import { BaseService } from 'src/app/system-common/services/base.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { CalendarOptions } from '@fullcalendar/core';

@Component({
  selector: 'sym-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  tabList: TabItem[];
  selectedTab: TabItem;
  breadCrumbList: BreadCrumb[];
  widgetPreference: any[] = [];
  components: any[] = [];
  componentsContestIncentive: any[] = [];
  subs = new Subscription();
  public isContestPageShow: boolean;
  public isLeader: boolean;
  public userLoginData;
  public dashboardData: any;

  constructor(
    public headerService: HeaderService,
    public settingService: SettingService,
    public service: BaseService,
    protected http: HttpClient
  ) {
    this.isContestPageShow = true;
    this.isLeader = false;
    this.widgetPreference = [
      {
        dashboardTypeCd: 'Performance',
      },
      {
        dashboardTypeCd: 'Production',
      },
      {
        dashboardTypeCd: 'ContestGraph',
      },
      {
        dashboardTypeCd: 'IncentiveGraph',
      },
      {
        dashboardTypeCd: 'Promotion',
      },
      {
        dashboardTypeCd: 'Segmentation',
      },
      {
        dashboardTypeCd: 'ApplicationStatus',
      },
      {
        dashboardTypeCd: 'PerformanceStatus',
      },
      {
        dashboardTypeCd: 'TeamPerformance',
      },
      {
        dashboardTypeCd: 'Earnings',
      },
    ];
  }

  ngOnInit() {
    this.settingService.removeSessionStorage('ApplicationStatus');
    this.settingService.removeSessionStorage('CheckerApplicationStatus');
    this.settingService.removeSessionStorage('AuditChanges');
    this.breadCrumbList = [];
    this.getPageHeader();
    this.userLoginData = undefined;
    if (sessionStorage.getItem('userLoginData') != undefined) {
      this.userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    }
    for (const role of this.userLoginData['userRoleList']) {
      if (role != 'AGENT') {
        this.isLeader = true;
        break;
      }
    }

    if (!this.isLeader) {
      this.widgetPreference = this.widgetPreference.filter(
        (item) =>
          item.dashboardTypeCd !== 'ApplicationStatus' &&
          item.dashboardTypeCd !== 'PerformanceStatus' &&
          item.dashboardTypeCd !== 'TeamPerformance'
      );
    }
    this.tabList = this.getTabList();

    if (this.tabList[0] != undefined) {
      this.selectedTab = this.tabList[0];
      this.tabList[0].isSelected = true;
    }
    this.getDashboardPreferences().subscribe((res) => {
      let resData = JSON.parse(JSON.stringify(res));

      let userdashboardSeq = resData?.data?.themePreference?.DarkTheme?.userdashboardSeq ?? null;
      this.settingService.setSessionStorageValue('userdashboardSeq', userdashboardSeq);

      // Call save theme API when userdashboardSeq is available
      if (resData?.data?.themePreference?.DarkTheme?.isRequired == 'Y') {
        this.settingService.setSessionStorageValue('currentSelectedTheme', 'dark.css');
        this.settingService.loadExternalStyle('dark.css', 'assets/theme/css/skin');

        if (userdashboardSeq) {
          this.saveDashboardTheme(userdashboardSeq, 'Y');
        }
      }
      let componentOrder = resData?.data;
      componentOrder = {
        AgentApplicationStatusComponent: '5',
        AgentPerformanceComponent: '2',
        AgentPerformanceStatusComponent: '6',
        AgentProductionStatusComponent: '1',
        ContestGraph: '3',
        IncentiveGraph: '4',
        Promotion: '8',
        Segmentation: '10',
        TeamPerformanceComponent: '7',
        EarningsComponent: '9',
      };
      this.components = Object.entries(componentOrder)
        .map(([label, order]) => ({ label, order: +order }))
        .sort((a, b) => a.order - b.order);
    });
  }

  private getPageHeader() {
    this.headerService.pageHeader = new PageHeader();
    this.headerService.pageHeader.title = 'Home';
  }

  protected getTabList(): TabItem[] {
    const tabs: TabItem[] = [
      {
        id: this.settingService.getLabelValue('production'),
        isSelected: true,
        imageSrc: 'fas fa-industry',
      },
      {
        id: this.settingService.getLabelValue('performance'),
        isSelected: false,
        imageSrc: 'fas fa-chart-line',
      },
      {
        id: this.settingService.getLabelValue('contest'),
        isSelected: false,
        imageSrc: 'fas fa-trophy',
      },
      {
        id: this.settingService.getLabelValue('incentive'),
        isSelected: false,
        imageSrc: 'fas fa-dollar-sign',
      },
      {
        id: this.settingService.getLabelValue('earnings'),
        isSelected: false,
        imageSrc: 'fas fa-wallet',
      },
      {
        id: this.settingService.getLabelValue('promotion'),
        isSelected: false,
        imageSrc: 'fas fa-medal',
      },
      {
        id: this.settingService.getLabelValue('segmentation'),
        isSelected: false,
        imageSrc: 'fas fa-object-group',
      },
      {
        id: this.settingService.getLabelValue('applications'),
        isSelected: false,
        imageSrc: 'fas fa-file-alt',
      },
      {
        id: this.settingService.getLabelValue('recruitment'),
        isSelected: false,
        imageSrc: 'fas fa-user-plus',
      },
      {
        id: this.settingService.getLabelValue('teamPerformance'),
        isSelected: false,
        imageSrc: 'fas fa-users',
      },
    ];

    if (!this.isLeader) {
      return tabs.filter(
        (tab) =>
          tab.id != this.settingService.getLabelValue('applications') &&
          tab.id != this.settingService.getLabelValue('recruitment') &&
          tab.id != this.settingService.getLabelValue('teamPerformance')
      );
    }

    return tabs;
  }

  public getDashboardPreferences() {
    let body = {
      agentId: this.userLoginData.agentId,
    };
    return this.service.httpPost('api/userdashboard/getDashboardPreferences', body);
  }

  public updateDashboardPreferences(body) {
    return this.http.post('api/userdashboard/dashboardPreference', body);
  }

  // New method to call savedashboardtheme API
  public saveDashboardTheme(userdashboardSeq: number, isRequired: string) {
    const payload = {
      userdashboardSeq: userdashboardSeq,
      isRequired: isRequired,
      agentId: this.userLoginData.agentId,
    };
    return this.http.post('api/userdashboard/savedashboardtheme', payload).subscribe((res) => {
      // console.log('Save Dashboard Theme Response:', res);
    });
  }

  setTab(tab: TabItem) {
    this.selectedTab = tab;
  }

  dropChart(e: CdkDragDrop<any[]>) {
    moveItemInArray(this.components, e.previousIndex, e.currentIndex);
    const payload = {
      dashboardPreferences: this.components.map((comp, idx) => ({
        dashboardTypeCd: comp.label,
        position: String(idx + 1),
        isRequired: 'Y',
      })),
      agentId: this.userLoginData.agentId,
    };
    this.updateDashboardPreferences(payload).subscribe((res) => {});

    // Also call save theme API after reordering
    let userdashboardSeq = this.settingService.getSessionStorageValue('userdashboardSeq');
    if (userdashboardSeq) {
      this.saveDashboardTheme(userdashboardSeq, 'Y');
    }
  }

  trackByFn(index: number, comp: any) {
    return comp.label;
  }

  removeChart(chartLabel: string) {
    this.components = this.components.filter((c) => c.label !== chartLabel);
  }

  ngOnDestroy(): void {
    this.service.clear();
  }
}
